import classNames from "classnames";
import { Link, useMatch } from "react-router-dom";

import { RobotoDivider } from "@/shared/components/RobotoDivider";
import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { SystemUserOnly } from "@/shared/components/SystemUserOnly";

import styles from "./Navigation.module.css";
import { navGroups, NavLink } from "./navigationLinks";

interface NavigationProps {
  /** Callback to be invoked when a navigation link is clicked. */
  onNavigate?: () => void;
}

/**
 * A component that renders the navigation links.
 */
export function Navigation(props: NavigationProps) {
  return (
    <div>
      <ul className={styles.navList}>
        {navGroups.features.map((link) => (
          <li className={styles.navItem} key={link.name}>
            <NavItem {...link} onClick={props.onNavigate} />
          </li>
        ))}
      </ul>

      <RobotoDivider />

      <ul className={styles.navList}>
        {navGroups.settingsAndGuides.map((link) => (
          <li className={styles.navItem} key={link.name}>
            <NavItem {...link} onClick={props.onNavigate} />
          </li>
        ))}
      </ul>

      <SystemUserOnly>
        <RobotoDivider />
        <ul className={styles.navList}>
          {navGroups.admin.map((link) => (
            <li className={styles.navItem} key={link.name}>
              <NavItem {...link} onClick={props.onNavigate} />
            </li>
          ))}
        </ul>
      </SystemUserOnly>
    </div>
  );
}

/**
 * A drawer navigation link button
 */
function NavItem(props: NavLink & { onClick?: () => void }) {
  const match = useMatch(props.link);
  const isActive = match !== null;

  const isExternal = props.isExternalLink;

  return (
    <Link
      to={props.link}
      target={isExternal ? "_blank" : "_self"}
      rel={isExternal ? "noopener noreferrer" : undefined}
      aria-label={isExternal ? `${props.name} (opens in new tab)` : props.name}
      className={classNames(styles.navLink, {
        [styles.active]: isActive,
      })}
      onClick={props.onClick}
    >
      <props.icon className={styles.navIcon} aria-hidden="true" />
      <RobotoTypography variant="body2" className={styles.linkText}>
        {props.name}
      </RobotoTypography>
    </Link>
  );
}
